export default __webpack_public_path__ + "static/media/vigor.d02e3ef0.png";